<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-container fluid>
<!--            <v-row v-if="$store.getters.homePageInformation.type != 'Allocator'" class="justify-center">-->
<!--                <v-alert v-if="eBookParticipation" class="mb-2 mx-5" outlined type="info">-->
<!--                    Έχετε επιλέξει να διαθέτετε συγγράμματα και ηλεκτρονικά για το ακαδημαϊκό έτος {{academicYear}}.-->
<!--                    <b @click="openHistoryModal" style="cursor: pointer"><u>-->
<!--                    Ιστορικό-->
<!--                </u></b>-->
<!--                </v-alert>-->
<!--                <v-alert class="mb-2 mx-5" style="background-image: radial-gradient(circle, rgba(42, 189, 162, 1) 0%, rgba(39, 36, 48, 1) 100%);"-->
<!--                         outlined icon="mdi-alert-circle-outline"-->
<!--                         type="warning"-->
<!--                         prominent-->
<!--                         border="bottom">-->
<!--                  Την Δευτέρα 03/07/2023 στο διάστημα 12:00 - 13:00, δεν θα είναι δυνατή η πρόσβαση στην ηλεκτρονική κοστολόγηση διδακτικών συγγραμμάτων, λόγω προγραμματισμένων εργασιών συντήρησης.-->
<!--                  <br/>Ζητούμε συγγνώμη για την αναστάτωση.-->

<!--                </v-alert>-->
<!--            </v-row>-->

            <v-row>
                <v-col lg="8" md="8" cols="12" sm="12">
                    <BooksTable  v-if="$store.getters.homePageInformation.type != 'Allocator'"/>
                    <AllocatorBooksTable v-else/>
                </v-col>
                <v-col lg="4" md="4" cols="12" sm="12">
                    <BookEdit v-if="$store.getters.homePageInformation.type != 'Allocator'" ref="bookEdit"/>
                    <AllocatorBookEdit v-else/>
                </v-col>
            </v-row>

        </v-container>
        <PublisherHistory :publisherHistory="publisherHistory"/>
    </div>
</template>

<script>
    import BooksTable from "./BooksTable";
    import BookEdit from "./BookEdit";
    import PublisherHistory from "../homePage/PublisherHistory";
    import request from "../../requests"
    import utils from "../../utilities"
    import AllocatorBooksTable from "./allocatorBook/AllocatorBooksTable";
    import AllocatorBookEdit from "./allocatorBook/AllocatorBookEdit";

    export default {
        name: "Books",
        components: {AllocatorBookEdit, AllocatorBooksTable, BookEdit, BooksTable, PublisherHistory},
        data: () => ({
            search: '',
            publisherHistory: [],
            headers: [
                {
                    text: 'Κωδικός',
                    align: 'start',
                    filterable: true,
                    value: 'name',
                },
                { text: 'Τίτλος', value: 'calories' },
                { text: 'Ενέργειες', value: 'fat', align: 'center' },
            ],
            isMounted: false,
        }),

        methods: {

            openHistoryModal() {

                var homePageInformationHistorys = JSON.parse(JSON.stringify(this.$store.getters.homePageInformation.history));
                this.publisherHistory = [];

                for (var homePageInformationHistory in homePageInformationHistorys) {
                    if (homePageInformationHistorys.hasOwnProperty(homePageInformationHistory)) {
                        var item = homePageInformationHistorys[homePageInformationHistory];
                        this.publisherHistory.push(item);
                    }
                }
                this.$store.commit('setPublisherHistory', true);
            },

            getAction(item) {

            },

            getRow(item) {

            },

            // //get all publisher books
            // getAllPublisherBooks() {
            //     var token = utils.getLocalStorage('token');
            //     if (token != null) {
            //         this.$store.commit('setLoadingModal', true);
            //         request.getAllPublisherBooks(token, this.getAllPublisherBooksCallBack);
            //     }
            //     else {
            //         this.$store.commit('setloginModal', true);
            //     }
            // },
            //
            // //call back publisher Books
            // getAllPublisherBooksCallBack(response) {
            //     this.counter++;
            //     console.log('books callback');
            //     this.$store.commit('setLoadingModal', false);
            //     this.$store.commit('setPublisherBooks', response);
            // }
        },

        computed: {

            academicYear: function () {

                var years = this.$store.getters.years;
                if (years.length > 0) {
                    return years[0].value + ' - ' + parseInt(years[0].value + 1)
                }
                return '';
            },


            eBookParticipation: function () {

                var homePageInformation = this.$store.getters.homePageInformation;
                var currentYear = this.$store.getters.editedYear;
                if (Object.keys(homePageInformation).length > 0 && currentYear != undefined) {
                    if (Object.keys(homePageInformation.history).length > 0) {
                        if (homePageInformation.history[currentYear] != undefined) {
                            return homePageInformation.history[currentYear].eBookstoreMembership;
                        }
                    }
                }
                return false;
            },
        },

        mounted(){
            this.isMounted = true;
        },

        created() {
            window.scrollTo(0, 0);
            // this.getAllPublisherBooks();
            this.$store.commit('setEditPublisherBook', {});
        }
    }
</script>

<style scoped>

</style>